<template>
   <div class="details">
       <breadcrumb :breadcrumb="crumbList"></breadcrumb>
       <div class="details_box">
           <div class="details_title">{{message.title}}</div>
           <div class="details_time">{{message.create_time}}</div>
           <div v-html="message.describe"></div>
       </div>
   </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb'
export default {
   data (){
       return {
           crumbList:[
               {name:'消息提醒',path:'/message'},
               {name:'系统消息',path:'/systemMessage'},
               {name:'通知详情',path:'/messageDetails'}
           ],
           message:{}
       }
   },
   components: {
       breadcrumb
   },
   watch: {
       
   },
   computed: { 
       
   },
   methods: { 
       getMessage(){
           this.$get('MessageDetail',{id:this.$route.query.orderId})
            .then(data => {
                this.message = data;
            }, error => {
                this.$message.error(error);
            });
       }
   },
   created() {
       
   },
   mounted() {
       this.getMessage();
   }
}
</script>

<style scoped lang='less'>
.details{
    &_box{
        margin-top:16px;
        border-top:1px solid #E1E1E1;
        padding-top:14px;
        padding: 14px 20px 0 20px;
    }
    &_title{
        font-size: 18px;
        font-weight: 500;
        margin-bottom:12px;
    }
    &_time{
        font-size:14px;
        color:#999;
        margin-bottom:24px;
    }
    
}
.t_c{
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/message/messageDetails.vue